import { graphql } from "../gql";

export const createFileAnnotationMutationDoc = graphql(`
  mutation createFileAnnotation(
    $fileId: ID!
    $input: CreateFileAnnotationInput!
  ) {
    createFileAnnotation(fileId: $fileId, input: $input) {
      ...FileUserAnnotationFragment
    }
  }
`);
